import {
  // useState,
  useRef,
  Fragment,
} from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import CloseIcon from "@mui/icons-material/Close";
import SkipNextIcon from "@mui/icons-material/SkipNext";

import APlayerControlButton from "./APlayerControlButton";
import SvgIconStyle from "../../../components/SvgIconStyle";
import { PATH_DASHBOARD } from "src/routes/paths";
import { AHidden } from "../../../components/@material-extend";
import usePlayer from "src/hooks/usePlayer";
import AfricastPlayer from "./Player";
import MaxLineText from "src/components/MaxLineText";

export default function DockedMiniPlayer() {
  const playerRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();

  const { playerState, setPlayerState, videoData, setVideoData, setMinimized } =
    usePlayer();

  return (
    <Fragment>
      <AHidden width="smUp">
        <Stack
          sx={{
            width: "100%",
            height: "auto",
            position: "fixed",
            left: 0,
            bottom: 0,
            zIndex: 100,
          }}
          direction="row"
        >
          <Box sx={{ position: "relative" }}>
            <AfricastPlayer width={200} height={98.5} ref={playerRef} />
            <Box
              sx={{
                top: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                position: "absolute",
                flexDirection: "column",
              }}
            >
              <Stack direction="row" sx={{ flexGrow: 1 }} alignItems="center">
                <Box
                  flexGrow={1}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {playerState.playing ? (
                    <APlayerControlButton
                      onClick={() => setPlayerState({ playing: false })}
                    >
                      <PauseIcon sx={{ fontSize: 40 }} />
                    </APlayerControlButton>
                  ) : (
                    <APlayerControlButton
                      onClick={() => setPlayerState({ playing: true })}
                    >
                      <PlayArrowIcon sx={{ fontSize: 40 }} />
                    </APlayerControlButton>
                  )}
                </Box>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ flexGrow: 1 }}
                >
                  <APlayerControlButton>
                    <SkipNextIcon sx={{ fontSize: 40 }} />
                  </APlayerControlButton>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Stack
            sx={{
              p: 1,
              width: "calc(100% - 175px)",
              bgcolor: "common.white",
              color: "text.secondary",
              height: 98.5,
            }}
          >
            <Stack direction="row" alignItems="center">
              <Typography
                variant="subtitle1"
                component={RouterLink}
                to={PATH_DASHBOARD.watch}
                sx={{
                  color: "text.secondary",
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                  flexGrow: 1,
                  // width: "calc(100% - 40px)",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {videoData.title}
              </Typography>
              <APlayerControlButton onClick={() => setVideoData(null)}>
                <CloseIcon sx={{ color: "text.secondary" }} />
              </APlayerControlButton>
            </Stack>
            <MaxLineText
              maxLine={2}
              variant="body2"
              text={videoData.feedData?.description || ""}
            />
            <Typography
              variant="body2"
              sx={{
                fontWeight: { xs: 700, md: 500 },
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {`HD | ${videoData.feedData?.releaseYear || ""} | 12+`}
            </Typography>
          </Stack>
        </Stack>
      </AHidden>

      <AHidden width="smDown">
        <Box
          sx={{
            width: 300,
            height: "auto",
            position: "fixed",
            right: 0,
            bottom: 0,
            zIndex: 100,
          }}
        >
          <Box sx={{ position: "relative" }}>
            {/* <AfricastPlayer width={300} height={168.8} /> */}
            <AfricastPlayer width={400} height={225} />
            <Box
              sx={{
                top: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                position: "absolute",
                flexDirection: "column",
              }}
            >
              <Stack direction="row" p={1}>
                <APlayerControlButton
                  onClick={() => {
                    navigate(`${PATH_DASHBOARD.watch}/${videoData.contentId}`, {
                      state: { prevPagePath: location.pathname },
                    });
                    setMinimized(false);
                  }}
                  // component={RouterLink}
                  // to={`${PATH_DASHBOARD.watch}/${videoData.contentId}`}
                  // state={{ prevPagePath: location.pathname }}
                >
                  <SvgIconStyle src="/static/vectors/MiniplayerExit.svg" />
                </APlayerControlButton>
                <Box flexGrow={1} />
                <IconButton
                  sx={{
                    bgcolor: "common.black",
                    color: "common.white",
                    "&:hover": { bgcolor: "common.black" },
                  }}
                  onClick={() => setVideoData(null)}
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack direction="row" sx={{ flexGrow: 1 }} alignItems="center">
                <Box
                  flexGrow={1}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {playerState.playing ? (
                    <APlayerControlButton
                      onClick={() => setPlayerState({ playing: false })}
                    >
                      <PauseIcon sx={{ fontSize: 40 }} />
                    </APlayerControlButton>
                  ) : (
                    <APlayerControlButton
                      onClick={() => setPlayerState({ playing: true })}
                    >
                      <PlayArrowIcon sx={{ fontSize: 40 }} />
                    </APlayerControlButton>
                  )}
                </Box>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ flexGrow: 1 }}
                >
                  <APlayerControlButton>
                    <SkipNextIcon sx={{ fontSize: 40 }} />
                  </APlayerControlButton>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Stack sx={{ bgcolor: "#D7D7D7", color: "text.secondary", p: 1 }}>
            <Typography variant="subtitle1">{videoData.title}</Typography>
            <MaxLineText
              maxLine={1}
              variant="body2"
              text={videoData.feedData?.description || ""}
            />
            <Typography variant="body2">{`HD | ${
              videoData.feedData?.releaseYear || ""
            } | 12+`}</Typography>
          </Stack>
        </Box>
      </AHidden>
    </Fragment>
  );
}
